export class FeatureStateUpdate {
    constructor(init) {
        Object.assign(this, init);
    }
}
//# sourceMappingURL=feature-state-update.js.map